var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-sort.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"sortOptions")),"selectedSort") != runtime.contextOrFrameLookup(context, frame, "null") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"sortOptions")),"selectedSort") != runtime.contextOrFrameLookup(context, frame, "None");
frame.set("sortFilterIsApplied", t_1, true);
if(frame.topLevel) {
context.setVariable("sortFilterIsApplied", t_1);
}
if(frame.topLevel) {
context.addExport("sortFilterIsApplied", t_1);
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") > 0) {
output += "\n\n    <li class=\"c-category-sort-by__li js-facet js-sort-default ";
if(!runtime.contextOrFrameLookup(context, frame, "sortFilterIsApplied")) {
output += "is-selected";
;
}
output += " isSortFilterApplied}}\" data-clear-query=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"sortOptions")),"resetQuery"), env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((lineno = 6, colno = 189, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 6, colno = 194, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"sort by",(lineno = 6, colno = 253, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_sort-label"]))])), env.opts.autoescape);
output += ">\n        <input type=\"radio\" id=\"default-sort-option-radio\" class=\"c-category-sort-by__input\" name=\"sortOption\"\n        ";
if(!runtime.contextOrFrameLookup(context, frame, "sortFilterIsApplied")) {
output += "checked";
;
}
output += " data-qa-featured-sort>\n        </input>\n\n        <label for=\"default-sort-option-radio\" class=\"c-category-sort-by__label\">\n            ";
output += runtime.suppressValue((lineno = 12, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_sort-label"])), env.opts.autoescape);
output += "\n        </label>\n    </li>\n\n    ";
frame = frame.push();
var t_4 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"sortOptions")),"availableSorts");
if(t_4) {var t_3 = t_4.length;
for(var t_2=0; t_2 < t_4.length; t_2++) {
var t_5 = t_4[t_2];
frame.set("sortOption", t_5);
frame.set("loop.index", t_2 + 1);
frame.set("loop.index0", t_2);
frame.set("loop.revindex", t_3 - t_2);
frame.set("loop.revindex0", t_3 - t_2 - 1);
frame.set("loop.first", t_2 === 0);
frame.set("loop.last", t_2 === t_3 - 1);
frame.set("loop.length", t_3);
var t_6;
t_6 = env.getFilter("trim").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"currencyFormattingInfo")),"currencyPrefix") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"currencyFormattingInfo")),"currencySuffix")));
frame.set("currencySymbol", t_6, true);
if(frame.topLevel) {
context.setVariable("currencySymbol", t_6);
}
if(frame.topLevel) {
context.addExport("currencySymbol", t_6);
}
output += "\n        ";
if(runtime.memberLookup((t_5),"key") == "tile_skuInfo_salePriceLow_Descending") {
output += "\n            ";
var t_7;
t_7 = (lineno = 20, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_sort-mobile-price-descending",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "currencySymbol")]})]));
frame.set("sortLabel", t_7, true);
if(frame.topLevel) {
context.setVariable("sortLabel", t_7);
}
if(frame.topLevel) {
context.addExport("sortLabel", t_7);
}
output += "\n        ";
;
}
else {
if(runtime.memberLookup((t_5),"key") == "tile_skuInfo_salePriceLow_Ascending") {
output += "\n            ";
var t_8;
t_8 = (lineno = 22, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_sort-mobile-price-ascending",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "currencySymbol")]})]));
frame.set("sortLabel", t_8, true);
if(frame.topLevel) {
context.setVariable("sortLabel", t_8);
}
if(frame.topLevel) {
context.addExport("sortLabel", t_8);
}
output += "\n        ";
;
}
else {
if(runtime.memberLookup((t_5),"key") == "tile_reviews_averageRating_Descending") {
output += "\n            ";
var t_9;
t_9 = (lineno = 24, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_sort-mobile-" + "" + runtime.memberLookup((t_5),"key")]));
frame.set("sortLabel", t_9, true);
if(frame.topLevel) {
context.setVariable("sortLabel", t_9);
}
if(frame.topLevel) {
context.addExport("sortLabel", t_9);
}
output += "\n        ";
;
}
else {
output += "\n            ";
var t_10;
t_10 = (lineno = 26, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_sort-" + "" + runtime.memberLookup((t_5),"key")]));
frame.set("sortLabel", t_10, true);
if(frame.topLevel) {
context.setVariable("sortLabel", t_10);
}
if(frame.topLevel) {
context.addExport("sortLabel", t_10);
}
output += "\n        ";
;
}
;
}
;
}
if(runtime.memberLookup((t_5),"isSelected")) {
output += "<li data-facet-value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"key"), env.opts.autoescape);
output += "\" class=\"c-category-sort-by__li js-facet is-selected\">\n\n            <input type=\"radio\" id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"key"), env.opts.autoescape);
output += "-radio\" class=\"c-category-sort-by__input\" name=\"sortOption\" data-qa-sort-option=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"cmSlug"), env.opts.autoescape);
output += "\" data-sort-key=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"key"), env.opts.autoescape);
output += "\" value=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_5),"queryString")), env.opts.autoescape);
output += "\"";
if(runtime.memberLookup((t_5),"isSelected")) {
output += "\n                    checked";
;
}
output += ">\n\n            </input>\n\n            <label for=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"key"), env.opts.autoescape);
output += "-radio\" class=\"c-category-sort-by__label\">\n                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sortLabel"), env.opts.autoescape);
output += "\n            </label>\n\n        </li>";
;
}
else {
output += "<li data-facet-value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"key"), env.opts.autoescape);
output += "\" class=\"c-category-sort-by__li js-facet\" ";
output += runtime.suppressValue((lineno = 48, colno = 91, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 48, colno = 96, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"sort by",runtime.memberLookup((t_5),"cmSlug")])), env.opts.autoescape);
output += ">\n\n            <input type=\"radio\" id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"key"), env.opts.autoescape);
output += "-radio\" class=\"c-category-sort-by__input\" name=\"sortOption\" data-sort-key=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"key"), env.opts.autoescape);
output += "\" value=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_5),"queryString")), env.opts.autoescape);
output += "\" data-qa-sort-option=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"cmSlug"), env.opts.autoescape);
output += "\">\n            </input>\n\n            <label for=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"key"), env.opts.autoescape);
output += "-radio\" class=\"c-category-sort-by__label\">\n                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sortLabel"), env.opts.autoescape);
output += "\n            </label>\n        </li>";
;
}
;
}
}
frame = frame.pop();
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-sort.j2"] , dependencies)